<template>
    <MeetingDetailsBlock
        iconName="comment"
        title="Notes"
    >
        <span
            @click.stop
            class="cursor-auto"
        >
            {{ notes }}
        </span>
    </MeetingDetailsBlock>
</template>

<script setup lang="ts">
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'

    const props = defineProps({
        notes: {
            type: String,
            required: true,
        },
    })
</script>
